import './Account.scss';
import Component from './Account.js';
export default Component;
